/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Crosspostingconnecthint22Inputs */

const en_crosspostingconnecthint22 = /** @type {(inputs: Crosspostingconnecthint22Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`For Facebook and Instagram, select all Pages and accounts you manage so posting works reliably.`)
};

const de_crosspostingconnecthint22 = /** @type {(inputs: Crosspostingconnecthint22Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wähle bei Facebook und Instagram alle von dir verwalteten Seiten und Konten aus, damit das Posten zuverlässig funktioniert.`)
};

/**
* | output |
* | --- |
* | "For Facebook and Instagram, select all Pages and accounts you manage so posting works reliably." |
*
* @param {Crosspostingconnecthint22Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const crosspostingconnecthint22 = /** @type {((inputs?: Crosspostingconnecthint22Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Crosspostingconnecthint22Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_crosspostingconnecthint22(inputs)
	return de_crosspostingconnecthint22(inputs)
});
export { crosspostingconnecthint22 as "crosspostingConnectHint2" }